import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const ChatUsageBar = ({ usage, limit }) => {
    const percentage = (usage / limit) * 100;

    return (
        <div className="roxy-panel__usage">
            <div className="roxy-panel__usage-label">
                Chat messages: {usage} / {limit}
            </div>
            <LinearProgress
                variant="determinate"
                value={Math.min(percentage, 100)}
                className="roxy-panel__usage-bar"
            />
        </div>
    );
};

export default ChatUsageBar;
